/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Cookies from "universal-cookie";
import NotificationUpgradeAccount from "../../components/NotificationUpgradeAccount";
import PrimaryButtonPageLevel from "../../components/button/primary-button/PrimaryButtonLevelPage";
import SecondaryButtonLevelPage from "../../components/button/secondary-button/SecondaryButtonLevelPage";
import PopupCloseButton from "../../components/button/special-button/PopupCloseButton";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ImageFromUrl from "../../components/parseImage/ImageFromUrl";
import { getListComplexity } from "../../config/complexity";
import { createPractice } from "../../config/practice";
import { getPracticeElectiveQuestion } from "../../reducers/practiceElectiveSlice";
import {
  clearState,
  createNewPractice,
  getAPracticeQuestions,
  getQuizInformation,
  setQuestionsAnswered,
  setQuizInformation,
} from "../../reducers/practiceQuestionSlice";
import { getALesson, getLessonSuccess } from "../../reducers/questionsSlice";
import "../../styling/layout-components/LessonLeftWrapper.css";
import PracticeElectiveMainWrapper from "../practice-elective/PracticeElectiveMainWrapper";
import { getListUnit, getUnitLessonProgress } from "../../config/ListLesson";
import { getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";
import ConstantStrings from "../../constants/ConstantStrings";

const EndLessonWrapper = ({
  header,
  handleEndLesson,
  handleReset,
  quiz,
  totalProgress,
  lesson,
  units
}) => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = cookies.get("signinUser");
  const lessonId = cookies.get("lessonId");
  const [showModal, setShowModal] = useState(false);
  const [openPopup, setOpenPopup] = useState("");
  const [practiceQuestionListId, setPracticeQuestionListId] = useState("");
  const [showRight, setShowRight] = useState(false);
  const [showPopupQuizSucceed, setShowPopupQuizSucceed] = useState(false);
  const [showPopupQuizContinue, setShowPopupQuizContinue] = useState(false);
  const [showPopupQuiz, setShowPopupQuiz] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showText, setShowText] = useState(false);
  const [unitLessonProgress, setUnitLessonProgress] = useState(null);
  const [listAnUnit, setListAnUnit] = useState(units);
  const [apiCalled, setAPICalled] = useState(false)
  const [isLoading, setIsLoading] = useState(true);

  var unitId = cookies.get("unitId");

  if (!quiz) {
    quiz = JSON.parse(localStorage.getItem("quizInformation"));
    dispatch(setQuizInformation(quiz));
  }
  const handleNextLesson = async () => {
    if (header?.nextLesson?.id.length > 0 && header?.unit.id) {
      dispatch(getALesson({ lessonId: header?.nextLesson.id, token }));
      dispatch(getLessonSuccess({ unitId: header?.unit.id }));
      cookies.set("lessonId", header?.nextLesson.id);
      cookies.set("unitId", header?.unit.id);
      cookies.set("indexLesson", listAnUnit?.lessons.findIndex(obj => obj._id === header?.nextLesson.id) > 9 ?
        listAnUnit?.lessons.findIndex(obj => obj._id === header?.nextLesson.id) :
        `0` + listAnUnit?.lessons.findIndex(obj => obj._id === header?.nextLesson.id))
      localStorage.setItem(
        "lesson_end_lesson",
        JSON.stringify({ nextLessonState: true })
      );
      navigate(0);
    } else if (header?.nextLesson?.id.length === 0) {
      const response = await getListUnit(cookies.get("unitId"), token);

      if (response?.result.lessons !== null) {
        dispatch(getALesson({ lessonId: response?.result?.lessons[0]?._id, token }));
        dispatch(getLessonSuccess({ unitId: header?.unit.id }));
        cookies.set("lessonId", response?.result?.lessons[0]?._id);
        cookies.set("unitId", header?.unit.id);

        cookies.set("indexLesson", listAnUnit?.lessons.findIndex(obj => obj._id === response?.result?.lessons[0]?._id) > 9 ?
          listAnUnit?.lessons.findIndex(obj => obj._id === response?.result?.lessons[0]?._id) :
          `0` + listAnUnit?.lessons.findIndex(obj => obj._id === response?.result?.lessons[0]?._id))
        localStorage.setItem(
          "lesson_end_lesson",
          JSON.stringify({ nextLessonState: true })
        );
        navigate(0);
      }
    }
  };
  const handleRetryLesson = (action) => {
    if (action !== "SHOW POPUP") {
      setOpenPopup("");
      if (action === "XEM LAI") {
        setTimeout(() => {
          handleEndLesson();
        }, 500);
      } else if (action === "HOC LAI") {
        handleReset();
        setTimeout(() => {
          handleEndLesson();
        }, 500);
      }
    } else {
      setOpenPopup("is-active");
    }
  };
  const handlePractice = async () => {
    try {
      const { result: listComplexity } = await getListComplexity();
      const { result: practiceId } = await createPractice({
        lessonIds: [lessonId],
        unitIds: [header?.unit.id],
        complexityIds: listComplexity.map((item) => item._id),
      });
      setPracticeQuestionListId(practiceId);
      setShowModal(true);
      dispatch(
        getPracticeElectiveQuestion({
          id: practiceId,
          page: 1,
          size: 50,
        })
      );
    } catch (error) {
      if (
        error?.response?.data?.errorMessage.includes(
          "Bạn không phải là tài khoản premium, không thể làm bài kiểm tra này"
        )
      ) {
        // return <NotificationUpgradeAccount isShowPopup={true}/>
        setShowError(true);
      } else {
        alert(error.response.data.errorMessage);
      }
    }
  };
  const handleSetShowError = (state) => {
    setShowError(state);
  };

  const handlePracticeUnit = async () => {
    const handleClickQuizz = () => {
      cookies.set("quizId", listAnUnit?.quizId);
      try {
        if (listAnUnit?.quizId) {
          let quizId = listAnUnit?.quizId;
          dispatch(
            getQuizInformation({
              quizId,
              token,
            })
          );
        }
      } catch (error) {
        console.log(error);
      }
    };
    handleClickQuizz()

    if (quiz?.practiceQuizId !== null && quiz?.practiceQuizIdLP === null) {
      setShowPopupQuiz(true);
      setOpenPopup("is-active")
    } else if (
      quiz?.practiceQuizIdLP !== null &&
      quiz?.practiceQuizId === null
    ) {

      setShowPopupQuizSucceed(true);
      setOpenPopup("is-active")
    } else if (
      quiz?.practiceQuizIdLP !== null &&
      quiz?.practiceQuizId !== null
    ) {

      setShowPopupQuizContinue(true);
      setOpenPopup("is-active")
    } else {
      dispatch(createNewPractice({ practiceId: JSON.parse(localStorage.getItem("quizInformation"))?._id, token }));
      cookies.set("practiceQuizId", JSON.parse(localStorage.getItem("quizInformation"))?._id);
      setTimeout(() => {
        navigate("/unit-quiz");
      }, 500);
    }
  };

  const handleClickPracticeQuiz = (action) => {
    if (action) {
      dispatch(setQuestionsAnswered([]));
      dispatch(clearState([]));
      if (action === "LAM LAI") {
        dispatch(createNewPractice({ practiceId: quiz._id, token }));
      } else if (action === "LAM TIEP") {
        if (quiz?.practiceQuizId) {
          cookies.set("practiceQuizId", quiz?.practiceQuizId);
          dispatch(
            getAPracticeQuestions({
              practiceQuizId: quiz?.practiceQuizId,
            })
          );
        }
      } else if (action === "XEM LOI GIAI") {
        if (quiz.practiceQuizIdLP) {
          cookies.set("practiceQuizIdLP", quiz.practiceQuizIdLP);
          dispatch(
            getAPracticeQuestions({
              practiceQuizIdLP: quiz.practiceQuizIdLP,
              page: 1,
              size: 50,
            })
          );
        }
      }
      setTimeout(() => {
        navigate("/unit-quiz");
      }, 500);
    }
  };
  const handleEndPractice = () => {
    setShowModal(false);
  };
  const closePopup = () => {
    setOpenPopup("");
  };

  function checkArrays(array1, array2) {
    const arrayLessonId = array2?.lessons?.map((item) => item._id)
    const filterProgress = array1?.filter((item) => arrayLessonId?.includes(item._id))
    if (filterProgress?.length === arrayLessonId?.length) {
      if (filterProgress?.every((item) => item.totalProgress === 100)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  useEffect(() => {
    if (!showRight) {
      if (totalProgress === 100) {
        setShowRight(true);
        setTimeout(() => {
          setShowText(true);
        }, 1000);
      } else {
        setTimeout(() => {
          setShowRight(true);
        }, 1000);
        setTimeout(() => {
          setShowText(true);
        }, 2000);
      }
    }

    const UnitLessonProgress = async () => {
      try {
        if (unitId !== null && unitId) {
          const response = await getUnitLessonProgress(unitId, token);
          setUnitLessonProgress(response.result);
        } else {
          const response = await getUnitLessonProgress(
            unitId,
            token
          );
          setUnitLessonProgress(response.result);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    const listUnit = async () => {
      try {
        if (unitId !== null && unitId) {
          const response = await getListUnit(unitId, token);
          setListAnUnit(response.result);
        } else {
          const response = await getListUnit(cookies.get("unitId"), token);
          setListAnUnit(response.result);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    if (!apiCalled) {
      listUnit()
      UnitLessonProgress()
      setAPICalled(true)
    }

    if (listAnUnit !== null && unitLessonProgress !== undefined) {
      setIsLoading(false)
    }

    if (!JSON.parse(localStorage.getItem("quizInformation")) && quiz) {
      localStorage.setItem("quizInformation", JSON.stringify(quiz));
    }
  }, [showRight, apiCalled, isLoading, listAnUnit, unitLessonProgress]);


  return (
    <BackgroundImageFromUrl
      objectId="admin/frontend-images/hub/background-list-unit.svg"
      className=" has-text-kurio-main-color-black m-auto is-flex is-align-items-center"
      style={{
        minHeight: "100vh",
        // maxWidth: "80rem",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // backgroundImage: "url('/')",
        // backgroundImage: "url('/images/hub/background-list-unit.svg')",
      }}
    >
      {showError && (
        <NotificationUpgradeAccount
          handleSetShowError={(state) => handleSetShowError(state)}
          isShowPopup={showError}
        />
      )}
      <div
        onClick={closePopup}
        className={`modal modal-background ${openPopup}`}
        style={{ zIndex: "999" }}
      >
        {/* popup retry lesson */}
        {!showPopupQuiz && !showPopupQuizContinue && !showPopupQuizSucceed && (
          <>
            <div
              className="is-relative has-background-kurio-main-color-white has-text-centered is-flex is-flex-direction-column is-align-items-center"
              style={{
                padding: "2.5rem",
                gap: "2rem",
                borderRadius: "2rem",
                width: "35.8125rem",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-2.8125rem",
                  left: "-2rem",
                }}
              >
                <PopupCloseButton />
              </div>
              <p style={{ width: "21.625rem" }}>
                {getConstantStringByLanguage(ConstantStrings.WANT_TO_VIEW_AGAIN)}
              </p>
              <div
                className="is-flex is-flex-direction-column"
                style={{ gap: "1rem" }}
              >
                <PrimaryButtonPageLevel
                  style={{ height: "4rem" }}
                  onClick={() => handleRetryLesson("XEM LAI")}
                >
                  {getConstantStringByLanguage(ConstantStrings.VIEW_AGAIN)}
                </PrimaryButtonPageLevel>
                <SecondaryButtonLevelPage
                  onClick={() => handleRetryLesson("HOC LAI")}
                >
                  {getConstantStringByLanguage(ConstantStrings.REPEAT_FROM_BEGINNING)}  
                </SecondaryButtonLevelPage>
              </div>
            </div>
          </>
        )}
        {/* popup quiz */}
        {(showPopupQuiz || showPopupQuizContinue || showPopupQuizSucceed) && (
          <div
            className="is-relative has-background-kurio-main-color-white has-text-centered is-flex is-flex-direction-column is-align-items-center"
            style={{
              padding: "2.5rem",
              gap: "2rem",
              borderRadius: "2rem",
              width: "35.8125rem",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-2.8125rem",
                left: "-2rem",
              }}
            >
              <PopupCloseButton />
            </div>
            {/* Đang làm bài và thoát ra ngoài */}
            {showPopupQuiz && (
              <div
                className="is-flex is-flex-direction-column is-align-items-center has-text-kurio-main-color-black"
                style={{ gap: "2rem" }}
              >
                {getConstantStringByLanguage(ConstantStrings.IN_PROGRESS_WARNING)}
                <div
                  className="is-flex is-flex-direction-row"
                  style={{ gap: "1rem" }}
                >
                  <SecondaryButtonLevelPage
                    onClick={() => handleClickPracticeQuiz("LAM LAI")}
                  >
                    {getConstantStringByLanguage(ConstantStrings.START_OVER)}
                  </SecondaryButtonLevelPage>
                  <PrimaryButtonPageLevel
                    style={{ height: "4rem" }}
                    onClick={() => handleClickPracticeQuiz("LAM TIEP")}
                  >
                    {getConstantStringByLanguage(ConstantStrings.QUIZ_CONTINUE)}
                  </PrimaryButtonPageLevel>
                </div>
              </div>
            )}
            {/* Đã nộp bài và có điểm 1 lần  nhưng làm đang làm bài và thoát ra ngoài*/}
            {showPopupQuizContinue && (
              <div
                className="is-flex is-flex-direction-column is-align-items-center has-text-kurio-main-color-black"
                style={{ gap: "1rem" }}
              >
                <div
                  className="is-flex is-flex-direction-column mb-4"
                  style={{ gap: "0.5rem" }}
                >
                  <p>{getConstantStringByLanguage(ConstantStrings.PREVIOUS_SCORE)}</p>
                  <p
                    className="has-text-kurio-main-color-purple has-text-weight-bold"
                    style={{ fontSize: "2.25rem" }}
                  >
                    {quiz?.correctAnswersLP} / {quiz?.generatedQuestionsLP}
                  </p>
                </div>
                <p>
                  {getConstantStringByLanguage(ConstantStrings.CONTINUE_LAST_SESSION)}
                </p>
                <PrimaryButtonPageLevel
                  style={{ height: "4rem" }}
                  onClick={() => handleClickPracticeQuiz("LAM TIEP")}
                >
                  {getConstantStringByLanguage(ConstantStrings.QUIZ_CONTINUE)}
                </PrimaryButtonPageLevel>
                <SecondaryButtonLevelPage
                  onClick={() => handleClickPracticeQuiz("LAM LAI")}
                >
                  {getConstantStringByLanguage(ConstantStrings.START_OVER)}
                </SecondaryButtonLevelPage>
                <SecondaryButtonLevelPage
                  onClick={() => handleClickPracticeQuiz("XEM LOI GIAI")}
                >
                  {getConstantStringByLanguage(ConstantStrings.SHOW_EXPLANATION)}
                </SecondaryButtonLevelPage>
              </div>
            )}
            {/* Đã nộp bài và có điểm */}
            {showPopupQuizSucceed && (
              <div
                className="is-flex is-flex-direction-column is-align-items-center has-text-kurio-main-color-black"
                style={{ gap: "1rem" }}
              >
                <div
                  className="is-flex is-flex-direction-column mb-4"
                  style={{ gap: "0.5rem" }}
                >
                  <p>{getConstantStringByLanguage(ConstantStrings.PREVIOUS_SCORE)}</p>
                  <p
                    className="has-text-kurio-main-color-purple has-text-weight-bold"
                    style={{ fontSize: "2.25rem" }}
                  >
                    {quiz?.correctAnswersLP} / {quiz?.generatedQuestionsLP}
                  </p>
                </div>
                <PrimaryButtonPageLevel
                  style={{ height: "4rem" }}
                  onClick={() => handleClickPracticeQuiz("LAM LAI")}
                >
                  {getConstantStringByLanguage(ConstantStrings.TRY_AGAIN)}
                </PrimaryButtonPageLevel>
                <SecondaryButtonLevelPage
                  onClick={() => handleClickPracticeQuiz("XEM LOI GIAI")}
                >
                  {getConstantStringByLanguage(ConstantStrings.SHOW_EXPLANATION)}
                </SecondaryButtonLevelPage>
              </div>
            )}
          </div>
        )}
      </div>
      {!showModal && (
        <div
          className="is-flex is-flex-direction-row is-align-items-center m-auto"
          style={{
            maxWidth: "39rem",
            gap: "4rem",
          }}
        >
          <div
            className={` end-lesson-container-left is-flex is-flex-direction-column is-align-items-center ${showRight ? "show" : ""
              }`}
            style={{ gap: "2.5rem" }}
          >
            <div
              className="is-flex is-flex-direction-column is-align-items-center"
              style={{ gap: "2.5rem" }}
            >
              <div
                className="is-flex is-flex-direction-column is-align-items-center"
                style={{ gap: "1rem" }}
              >
                <ImageFromUrl
                  objectId="admin/frontend-images/exercise/end-lesson.svg"
                  alt=""
                  style={{ width: "3rem" }}
                />
                <p className="is-size-1 has-text-weight-bold">{getConstantStringByLanguage(ConstantStrings.CONGRATULATION)}</p>
              </div>
              {totalProgress === 100 && (
                <>
                  <div
                    className="is-flex is-flex-direction-column is-align-items-center is-size-6"
                    style={{ gap: "2.5rem" }}
                  >
                    <img src="/images/exercise/icon-ga.svg" alt="" />
                    <div className="has-text-centered">
                      <p className="">{getConstantStringByLanguage(ConstantStrings.COMPLETED_LESSON)}</p>
                      <p className="has-text-weight-bold">{header?.title}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
            {totalProgress !== 100 && (
              <div
                className="is-flex is-flex-direction-column"
                style={{ gap: "2.5rem", width: "20rem" }}
              >
                <div className="is-flex is-flex-direction-column is-align-items-center is-relative">
                  <div
                    className="is-size-3 is-flex is-flex-direction-column is-justify-content-center is-align-items-center has-text-weight-bold has-text-centered has-background-kurio-main-color-white"
                    style={{
                      borderRadius: "1rem",
                      padding: "1.5rem 2.25rem 4rem 2.25rem",
                      border: "0.09375rem solid #0a2a66",
                      boxShadow: " 0.125rem 0.125rem 0rem 0rem #0a2a66",
                    }}
                  >
                    <span style={{ fontSize: "6rem" }}>60</span>
                    <img
                      style={{
                        marginTop: "-1rem",
                        width: "4.0056rem",
                        height: "4rem",
                      }}
                      src="/images/hub/star.png"
                      alt=""
                    />
                  </div>
                  <div
                    className=""
                    style={{
                      top: "-3.75rem",
                      right: "0rem",
                      width: "14.3125rem",
                      // height: "5.625rem",
                    }}
                  >
                    <div
                      className="is-flex is-flex-direction-row"
                      style={{
                        position: "absolute",
                        left: "14%",
                        right: "0%",
                        top: "78%",
                        bottom: "0%",
                        zIndex: "100",
                        width: "5.75rem",
                        height: "5.625rem",
                      }}
                    >
                      <ImageFromUrl
                        style={{ height: "5.625rem" }}
                        objectId="admin/frontend-images/exercise/badge-image.svg"
                        alt=""
                      />
                    </div>
                    <div
                      className=" has-text-weight-bold is-kurio-yellow-dark has-text-kurio-main-color-black is-flex is-justify-content-center is-align-items-center has-background-kurio-yellow-light-3"
                      style={{
                        position: "absolute",
                        left: "30.09%",
                        right: "0%",
                        top: "83.44%",
                        zIndex: "99",
                        bottom: "0%",
                        width: "11.4375rem",
                        height: "4rem",
                        border: "0.25rem #E2AD25 solid",
                        padding: "0.75rem 1.5rem 0.75rem 4rem",
                        borderRadius: "2rem",
                        fontSize: "0.875rem",
                      }}
                    >
                      <span
                        className="has-text-center"
                        style={{ width: "5.4375rem" }}
                      >
                        {getConstantStringByLanguage(ConstantStrings.COMPLETE_LESSON)}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="is-flex is-flex-direction-column is-align-items-center is-size-6"
                  style={{ gap: "0.5rem" }}
                >
                  <p className="">{getConstantStringByLanguage(ConstantStrings.COMPLETED_LESSON)}</p>
                  <p className="has-text-weight-bold">{header?.title}</p>
                </div>
              </div>
            )}
          </div>
          <div className="columns is-centered m-0 p-0">
            {/* {showRight && (
            )} */}
            <div
              className={`${showText ? "show" : ""
                } end-lesson-container is-flex is-flex-direction-column`}
              style={{ gap: "1.5rem" }}
            >
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="128"
                  height="83"
                  viewBox="0 0 128 83"
                  fill="none"
                >
                  <path
                    opacity="0.6"
                    d="M1.74111 1.3149C0.645832 1.45788 -0.126155 2.46169 0.016827 3.55697C0.159809 4.65224 1.16362 5.42423 2.25889 5.28125L1.74111 1.3149ZM122 82.5L127.667 60.1121L105.445 66.3983L122 82.5ZM5.88814 4.88699C6.98847 4.7903 7.80207 3.81992 7.70538 2.71959C7.60869 1.61926 6.63831 0.805654 5.53798 0.902347L5.88814 4.88699ZM20.7917 0.63812C19.6884 0.585744 18.7515 1.43771 18.6992 2.54104C18.6468 3.64436 19.4987 4.58124 20.6021 4.63362L20.7917 0.63812ZM27.9638 5.20606C29.0619 5.32453 30.0483 4.5303 30.1667 3.43211C30.2852 2.33391 29.491 1.3476 28.3928 1.22913L27.9638 5.20606ZM43.4099 3.7571C42.3336 3.50899 41.2599 4.1804 41.0118 5.25674C40.7637 6.33309 41.4351 7.40677 42.5114 7.65488L43.4099 3.7571ZM49.645 9.53117C50.704 9.8451 51.817 9.24109 52.131 8.18207C52.4449 7.12306 51.8409 6.01006 50.7819 5.69612L49.645 9.53117ZM65.0932 10.9631C64.0841 10.5138 62.9019 10.9676 62.4526 11.9767C62.0033 12.9857 62.457 14.168 63.4661 14.6173L65.0932 10.9631ZM70.0878 17.8448C71.0631 18.3633 72.2741 17.993 72.7926 17.0177C73.3111 16.0424 72.9408 14.8314 71.9655 14.3129L70.0878 17.8448ZM84.8993 22.4489C84.0107 21.7929 82.7584 21.9814 82.1024 22.87C81.4463 23.7586 81.6348 25.0109 82.5234 25.6669L84.8993 22.4489ZM88.2537 30.2455C89.0895 30.9676 90.3525 30.8755 91.0746 30.0397C91.7967 29.2039 91.7046 27.9409 90.8688 27.2187L88.2537 30.2455ZM101.633 38.0867C100.919 37.244 99.6568 37.1398 98.8141 37.8539C97.9714 38.568 97.8671 39.83 98.5813 40.6727L101.633 38.0867ZM103.107 46.4478C103.754 47.3425 105.005 47.5427 105.899 46.895C106.794 46.2473 106.994 44.9969 106.347 44.1022L103.107 46.4478ZM114.375 57.1186C113.864 56.1392 112.656 55.7593 111.677 56.2701C110.698 56.7808 110.318 57.9888 110.829 58.9682L114.375 57.1186ZM114.002 65.5949C114.445 66.6066 115.625 67.0672 116.636 66.6238C117.648 66.1804 118.109 65.0008 117.665 63.9892L114.002 65.5949ZM122.887 78.2874C122.571 77.229 121.457 76.627 120.398 76.9428C119.34 77.2586 118.738 78.3727 119.054 79.4311L122.887 78.2874ZM2.25889 5.28125C3.41802 5.12993 4.62923 4.99762 5.88814 4.88699L5.53798 0.902347C4.22507 1.01772 2.95793 1.15605 1.74111 1.3149L2.25889 5.28125ZM20.6021 4.63362C22.9866 4.74681 25.446 4.93445 27.9638 5.20606L28.3928 1.22913C25.7943 0.948817 23.2551 0.755055 20.7917 0.63812L20.6021 4.63362ZM42.5114 7.65488C44.8727 8.19919 47.2543 8.82248 49.645 9.53117L50.7819 5.69612C48.3099 4.96335 45.8487 4.31928 43.4099 3.7571L42.5114 7.65488ZM63.4661 14.6173C65.6878 15.6066 67.8981 16.6807 70.0878 17.8448L71.9655 14.3129C69.6912 13.1038 67.3972 11.9891 65.0932 10.9631L63.4661 14.6173ZM82.5234 25.6669C84.4694 27.1036 86.382 28.6284 88.2537 30.2455L90.8688 27.2187C88.9182 25.5335 86.9257 23.9451 84.8993 22.4489L82.5234 25.6669ZM98.5813 40.6727C100.138 42.5101 101.649 44.434 103.107 46.4478L106.347 44.1022C104.829 42.0054 103.255 40.0014 101.633 38.0867L98.5813 40.6727ZM110.829 58.9682C111.939 61.0976 112.998 63.3056 114.002 65.5949L117.665 63.9892C116.626 61.618 115.528 59.3286 114.375 57.1186L110.829 58.9682Z"
                    fill="#0A2A66"
                  />
                </svg>
              </div>
              {header?.nextLesson?.id.length > 0 && (
                <PrimaryButtonPageLevel
                  // isDarkColor={true}
                  style={{
                    height: "4rem",
                    outline: "0.09375rem solid #0a2a66",
                    boxShadow: " 0.125rem 0.125rem 0rem 0rem #0a2a66",
                    borderRadius: "1rem",
                  }}
                  onClick={handleNextLesson}
                >
                  {getConstantStringByLanguage(ConstantStrings.CONTINUE_LEARNING)}
                </PrimaryButtonPageLevel>
              )}

              {isLoading ? (
                <div>
                  Loading...
                </div>
              ) : (
                <>
                  {header?.nextLesson?.id.length === 0 && quiz !== null && (
                    unitLessonProgress !== null && listAnUnit !== undefined && checkArrays(unitLessonProgress, listAnUnit) ? (
                      <>
                        <PrimaryButtonPageLevel
                          // isDarkColor={true}
                          style={{
                            height: "4rem",
                            border: "0.09375rem solid #0a2a66",
                            boxShadow: " 0.125rem 0.125rem 0rem 0rem #0a2a66",
                            borderRadius: "1rem",
                          }}
                          onClick={handlePracticeUnit}
                        >
                          {getConstantStringByLanguage(ConstantStrings.GOAL)}
                        </PrimaryButtonPageLevel>
                      </>
                    ) : (
                      <PrimaryButtonPageLevel
                        // isDarkColor={true}
                        style={{
                          height: "4rem",
                          outline: "0.09375rem solid #0a2a66",
                          boxShadow: " 0.125rem 0.125rem 0rem 0rem #0a2a66",
                          borderRadius: "1rem",
                        }}
                        onClick={handleNextLesson}
                      >
                        {getConstantStringByLanguage(ConstantStrings.CONTINUE_LEARNING)}
                      </PrimaryButtonPageLevel>
                    )
                  )}

                  <PrimaryButtonPageLevel
                    // isDarkColor={true}
                    style={{
                      height: "4rem",
                      outline: "0.09375rem solid #0a2a66",
                      boxShadow: " 0.125rem 0.125rem 0rem 0rem #0a2a66",
                      borderRadius: "1rem",
                    }}
                    onClick={handlePractice}
                  >
                    {getConstantStringByLanguage(ConstantStrings.PRACTICE)}
                  </PrimaryButtonPageLevel>

                  <PrimaryButtonPageLevel
                    isDarkColor={true}
                    style={{
                      height: "4rem",
                      outline: "0.09375rem solid #0a2a66",
                      boxShadow: " 0.125rem 0.125rem 0rem 0rem #0a2a66",
                      borderRadius: "1rem",
                    }}
                    onClick={() => handleRetryLesson("SHOW POPUP")}
                  >
                    {getConstantStringByLanguage(ConstantStrings.VIEW_AGAIN)}
                  </PrimaryButtonPageLevel>
                  <a
                    className="has-text-centered has-text-kurio-main-color-black back-to-unit is-relative"
                    href="/list-lesson"
                  >
                    {getConstantStringByLanguage(ConstantStrings.BACK_TO_UNIT)}
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <PracticeElectiveMainWrapper
          practiceQuestionListId={practiceQuestionListId}
          handleEndPractice={handleEndPractice}
        />
      )}
    </BackgroundImageFromUrl>
  );
};
function mapStateToProps(state) {
  return {
    header: state.questions.header,
    lesson: state.questions.lesson,
    quiz: state.practiceQuestion.quizInformation,
    units: state.grades.units,
  };
}
export default connect(mapStateToProps)(EndLessonWrapper);
